import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {MapsCommonService} from "../../services/mapsCommon.service";

export class AddressesMapComponents implements IController {
  address: any;
  addresses: any;
  editingAddress: any;
  enableSearch: any;
  addMarkerEnabled: any;
  markerPurpose: any;
  onSelect: Function;
  onLocationSelect: Function;
  onEditingAddressChange: Function;

  readonly siteLocation;
  private mapTypeIds: any = {
    roadmap: 'ROADMAP',
    satellite: 'SATELLITE'
  };
  private filters: any = {
    traffic: false,
    addresses: true,
    satellite: false
  };
  private addressMarker: any;
  private map: any;
  private addressesMarkers = [];
  private editingMarkers = [];
  private locationQuery = undefined;
  private markerEvents: any;
  private isReady: boolean;

  constructor(private mapsCommonService: MapsCommonService, private $timeout: ITimeoutService) {
    this.siteLocation = this.mapsCommonService.getSiteLocation();
    this.addressMarker = {
      options: {
        icon: this.mapsCommonService.getTaskMarkerIcon(undefined, undefined, false, '#212121'),
        visible: true
      }
    };
  }

  $onInit() {
    this.map = {
      isReady: false,
      center: this.siteLocation || _.get(this.address, 'location'),
      zoom: 12,
      events: {
        idle: (map) => {
          if (!this.isReady) {
            this.isReady = true;
            google.maps.event.trigger(map, 'resize');
            this.centerMap();
            // resizeService.resize();
          }
        },
        click: (map, eventType, event) => {
          if (this.addMarkerEnabled) {
            this.$timeout(0).then(() => {
              const lat = event[0].latLng.lat();
              const lng = event[0].latLng.lng();
              this.onLocationSelect({location: {lat: lat, lng: lng}});
            });
          }
        }
      },
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        mapTypeControl: false,
        scaleControl: true,
        mapTypeId: google.maps.MapTypeId[this.mapTypeIds.roadmap]
      },
      bounds: {}
    };
    this.markerEvents = {
      dragend: (marker, eventName, args) => {
        const lat = marker.getPosition().lat();
        const lng = marker.getPosition().lng();

        if (!this.editingAddress.validatedAddress) {
          this.editingAddress.validatedAddress = {};
        }

        if (this.editingAddress.validatedAddress.placeId) {
          this.editingAddress.validatedAddress.placeId = undefined;
        }

        this.onEditingAddressChange();

        this.editingAddress.validatedAddress.location = {
          lat: lat,
          latitude: lat,
          lng: lng,
          longitude: lng
        };
      }
    };
    if (this.addresses) {
      this.addressesMarkers = this.createAddressesMarkers(this.addresses, 'regular', false);
    }
  }

  $onChanges(changes) {
    if (changes.addresses && !changes.addresses.isFirstChange()) {
      this.addressesMarkers = _.isEmpty(this.addresses) ? [] : this.createAddressesMarkers(this.addresses, 'regular', false);
      this.centerMap();
    }

    if (changes.address && !changes.address.isFirstChange()) {
      this.centerMap();
    }

    if (changes.editingAddress && !changes.editingAddress.isFirstChange()) {
      if (this.editingAddress && (!_.isUndefined(this.editingAddress.location.latitude) && !_.isUndefined(this.editingAddress.location.longitude))) {
        this.editingMarkers = this.createAddressesMarkers([this.editingAddress], 'edit', true);

        this.updateValidatedAddress(this.editingAddress, angular.copy(this.editingAddress.location));

        this.map.center = angular.copy(this.editingAddress.location);
        this.map.zoom = 15;
      } else {
        this.editingMarkers = [];
        this.centerMap();
      }
    }
  }

  onMapTypeChange(isSatelliteEnabled) {
    this.map.options.mapTypeId = google.maps.MapTypeId[isSatelliteEnabled ? this.mapTypeIds.satellite : this.mapTypeIds.roadmap];
  }

  onAddressChange(address) {
    if (address && address.placeId) {
      const addressCopy = angular.copy(address);

      if (this.editingMarkers.length) {
        this.editingMarkers[0].coords = address.location;
      } else {
        this.editingMarkers = this.createAddressesMarkers([address], 'edit', true);
      }

      this.updateValidatedAddress(this.editingAddress, address.location);
      this.editingAddress.validatedAddress.placeId = address.placeId;

      this.map.zoom = 15;
      this.map.center = addressCopy.location;
    }
  }

  centerMap() {
    const coordinates = this.getAddressesCoordinates();

    if (coordinates.length > 1) {
      this.map.bounds = this.mapsCommonService.getCoordinatesBounds(coordinates);
    } else if (coordinates.length === 1) {
      this.map.center = angular.copy(coordinates[0]);
      this.map.zoom = 15;
    } else {
      this.map.center = {latitude: this.siteLocation.lat, longitude: this.siteLocation.lng};
      this.map.zoom = 12;
    }
  }

  onTaskMarkerClick(marker, eventName, markerModel) {
    this.onSelect({id: markerModel.id})
  }

  // ******************************
  //        Internal methods
  // ******************************

  private createAddressesMarkers(addresses, type, isDraggable) {
    return this.mapsCommonService.buildMarkersByAddresses(addresses, type, isDraggable);
  }

  private getAddressesCoordinates() {
    const addressLocation = _.get(this.address, 'location');
    const addressCoords = addressLocation ? {
      latitude: _.isUndefined(addressLocation.latitude) ? addressLocation.lat : addressLocation.latitude,
      longitude: _.isUndefined(addressLocation.longitude) ? addressLocation.lng : addressLocation.longitude
    } : undefined;
    const coordinates = [addressCoords, ..._.map(this.addressesMarkers, 'coords')];

    return _.filter(coordinates, (coords) => coords && _.isFinite(coords.latitude) && _.isFinite(coords.longitude));
  }

  private updateValidatedAddress(editingAddress, location) {
    if (!editingAddress.validatedAddress) {
      editingAddress.validatedAddress = {};
    }

    editingAddress.validatedAddress.location = location;
  }


}

angular
  .module('bringoz.admin.map')
  .component('addressesMap', {
    bindings: {
      address: '<?',
      addresses: '<?',
      editingAddress: '<',
      enableSearch: '<',
      addMarkerEnabled: '<?',
      markerPurpose: '<?',
      onSelect: '&',
      onLocationSelect: '&?',
      onEditingAddressChange: '&?'
    },
    template: require('./addresses-map.html').default,
    controller: AddressesMapComponents
  });
